// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/event","name":"event","icon":"ScheduleOutlined","parentId":"ant-design-pro-layout","id":"3"},"4":{"name":"list","path":"/event/list","icon":"UnorderedListOutlined","parentId":"3","id":"4"},"5":{"path":"/event/list/:id","layout":false,"hideInMenu":true,"parentId":"3","id":"5"},"6":{"path":"/event/campaign/:id","hideInMenu":true,"parentId":"3","id":"6"},"7":{"path":"/","redirect":"/event/list","parentId":"ant-design-pro-layout","id":"7"},"8":{"layout":false,"path":"*","id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__User__login__index" */'@/pages/User/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__Events__index" */'@/pages/Events/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Events__index" */'@/pages/Events/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__Events__index" */'@/pages/Events/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__Events__index" */'@/pages/Events/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/Users/caocuong.tran/Desktop/SEA/GRN/GRN.AOV-planing-react/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
